import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-73" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-74" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-4 pb-10 px-4 md:pt-6 md:pb-16 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-75">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(196,181,224,0.25) 0%, rgba(196,181,224,0.08) 40%, transparent 70%)'
    }} data-id="element-76" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-77">
        <span className="inline-block py-1 px-3 rounded-full bg-mint/10 text-mint font-semibold text-sm mb-3 tracking-wide uppercase" data-id="element-78">
          🥑Salud en tu Plato™
        </span>

        <h1 className="md:text-6xl lg:text-7xl mb-4 font-[900] font-['Open_Sans',_sans-serif] text-white text-[24px]" data-id="element-79">
          Tu año de consultas nutricionales{' '}
          <span className="text-[#C4B5E0]" data-id="element-80">resueltas</span>
        </h1>

        <div className="mb-4 flex justify-center" data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/sNBJAzh3U6MtBrMVZF7aJN/e4842922-f6a9-4a2b-8e6d-35ff042dbd8c.png" alt="Megapack Nutricionistas Kit Profesional" className="w-full max-w-[420px] md:max-w-lg drop-shadow-2xl pl-[60px] pr-[60px]" data-id="element-82" />
        </div>

        <p className="md:text-3xl italic text-mint/80 mb-4 max-w-4xl mx-auto text-[18px] font-[800] font-[Avenir,_sans-serif]" data-id="element-83">
          "Listo para usar. Sin buscar más. Sin improvisar. Sin perder
          domingos."
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-5 text-[16px]" data-id="element-84">
          El sistema para nutricionistas en Argentina: consulta + planificación
          + protocolos + seguimiento + criterio clínico, listo para aplicar
          desde hoy. Sin armar desde cero. Sin dudar en consulta.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-6 max-w-4xl mx-auto" data-id="element-85">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-mint/10 px-3 py-1.5 rounded-md text-sm text-white/80 font-medium shadow-sm" data-id="element-86">
              <span className="text-mint" data-id="element-87">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-mint hover:bg-mint/80 text-black font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-xl shadow-lg shadow-mint/20 transition-colors" data-id="element-88">
          🧠QUIERO MI MEGAPACK AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 mt-4" data-id="element-89">
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-90">
            <Target size={16} className="text-mint" data-id="element-91" />
            Enfoque real
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-92">
            <ShieldCheck size={16} className="text-mint" data-id="element-93" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-94">
            <CreditCard size={16} className="text-mint" data-id="element-95" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}